import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'tm-verification-status',
  templateUrl: './tm-verification-status.component.html',
  styleUrls: ['./tm-verification-status.component.scss']
})
export class TmVerificationStatusComponent implements OnInit {
  @Input() verification_status_list;
  @Input() verificationObj;
  @Input() form_control;
  @Input() field;
  @Input() section;
  @Input() form_group;
  @Input() is_section;
  @Input() callbackFn;
  @Input() alertId;
  @Input() type;
  @Input() control_class = "justify-content-end"
  constructor(
    // private profile_svc: ProfileSettingsService
  ) { }

  ngOnInit(): void {
    this.init();
    // this.profile_svc.change_detection.subscribe(res => {
    //   this.init();
    // })
  }
  ngOnChanges(changes): void {
    if (changes && changes.verificationObj) {
      this.init();
    }
  }

  init() {
    if (this.type == 2) {
      if (!this.field.verificationStatus) {
        this.field.verificationStatus = 1;
      }
      this.statusChanged(this.field.verificationStatus)
    }
    else {
      if (!this.verificationObj[this.field.fieldID]) {
        this.verificationObj[this.field.fieldID] = 1;
      }
      this.statusChanged(this.verificationObj[this.field.fieldID])
    }
  }

  statusChanged(id, clicked?) {
    if (this.type == 2) {
      this.field.verificationStatus = id;
    }
    else {
      this.verificationObj[this.field.fieldID] = id;

      if (this.verificationObj[this.field.fieldID] == 3) {
        // this.form_group.get(this.field.fieldID).disable();
      }
      else {
        this.form_group.get(this.field.fieldID).enable();
      }
      if (this.is_section && this.section && this.section.sectionFields) {
        if (clicked) {
          this.removeVerification(id, this.section, this.verificationObj)
        }
      }
      if (this.is_section && this.section.enableApiCallForVerification && clicked) {
        try {
          this.callbackFn['updateStatusLog'](this.section.fieldID, this.section.label, id);
        }
        catch (err) {

        }
      }

      if (!this.is_section && this.field.enableApiCallForVerification && clicked) {
        try {
          this.callbackFn['updateStatusLog'](this.field.fieldID, this.field.label, id);
        }
        catch (err) {

        }
      }
      if (this.is_section) {
        try {
          this.section.ref.open();
        } catch (error) {

        }
      }
    }
  }


  removeVerification(id, section, verificationObj) {
    verificationObj[section.fieldID] = id;
    if (section && section.sectionFields && section.sectionFields.length) {
      for (let index = 0; index < section.sectionFields.length; index++) {
        let element = section.sectionFields[index];
        verificationObj[element.fieldID] = id;
      }
    }
    if (section.sections && section.sections.length) {
      for (let i = 0; i < section.sections.length; i++) {
        try {
          this.removeVerification(id, section.sections[i], verificationObj)
        }
        catch (err) {

        }
      }
    }
  }
}